export class EmailEdit {
	To: string | null = null;
	ValidationRules: Record<string, any> | null = {};
}
